module.exports = __webpack_public_path__ + "img/signUpBtnBg2.001717ad.png";